/**
 * User profile update Zod schema
 */

import { z } from 'zod'

export const updateUserProfileSchema = z.object({
  firstName: z.string().min(1).max(100).optional(),
  lastName: z.string().min(1).max(100).optional(),
  timezone: z.string().max(100).optional(),
})

export type UpdateUserProfileInput = z.infer<typeof updateUserProfileSchema>
